import React from 'react';
import './HeroSection.css';
import ButtonPage from '../ButtonPage/ButtonPage';


const HeroSection = () => {
  return (
    <section className="hero">
      {/* Content container for text and form */}
      <div className="hero-content">
        <h3 className="hero-headline"> {/* Changed class name for clarity */}
          LOSE WEIGHT WITHOUT SHAME, EXTREME DIETS, OR CONSTANT FRUSTRATION
        </h3>

        {/* Removed the commented-out H1 */}

        <p className="hero-subheadline"> {/* Changed class name for clarity */}
          <span>
            I help individuals over 100KG reach a healthy, sustainable weight—no
            guilt, no restrictive diets, just real, lasting results.
          </span>
        </p>

       <ButtonPage/>
        <p className="hero-testimonial"> {/* Changed class name for clarity */}
          1000+ People Have Already Transformed Themselves
        </p>
      </div>
    </section>
  );
};

export default HeroSection;